module.exports = __webpack_public_path__ + "static/media/page_03_a.de95351c.jpg";